import React from "react";
import "./index.scss";
import { FieldAttributes, useField } from "formik";
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import radioCheckedIcon from "../../../images/radio_checked.svg";
import radioUnCheckedIcon from "../../../images/radio_unchecked.svg";
import { ReactSVG } from "react-svg";

export interface SelectOption {
    label: string;
    value: any;
}

interface Props {
    options?: SelectOption[];
    backEndName: string;
    setFieldToUpdate: (fieldToUpdate: any) => void;
    onChangeListener?: (val: any) => void;
    value?: any;
    name: string;
    isProcessingOpenOnUpdate?: boolean
}

export const SelectOneRadioOld = (props: FieldAttributes<Props>) => {
    const {name, backEndName, setFieldToUpdate, onChangeListener, value, options, isProcessingOpenOnUpdate} = props;

    const [_, __, helpers] = useField({name});

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if(onChangeListener){
            onChangeListener(event.target.value);
        }
        helpers.setValue(event.target.value);
        setFieldToUpdate({name: backEndName, value: event.target.value, isProcessingOpenOnUpdate: !!isProcessingOpenOnUpdate});
    };

    const isIos = /\((iPhone|iPad);/.test(window.navigator.userAgent)
    

    return (
        <div className='select-one-radio'>
            <RadioGroup row={true} className={'select-one-radio-group'} value={value} onChange={onChange}>
                
                {Object.entries(options).map(([index,val]) => {
                    return <FormControlLabel id={name + '_' + index}
                         value={val.value}
                         key={index}
                         className={`select-one-radio-control-label ${val === value ? 'active' : 'inactive'}`}
                         control={
                            <Radio className='select-one-radio-item'
                                 icon={  isIos
                                     ? <object className="select-one-radio_ios_costyl" data={radioUnCheckedIcon} type="image/svg+xml"></object>
                                     : <ReactSVG src={radioUnCheckedIcon}/>
                                 }
                                 checkedIcon={ isIos
                                     ? <object className="select-one-radio_ios_costyl" data={radioCheckedIcon} type="image/svg+xml"></object>
                                     : <ReactSVG src={radioCheckedIcon}/>
                                 } />
                         }
                         label={val.label}/>
                })}
            </RadioGroup>
        </div>
    )
};